<template>
  <div class="site-loader">
    <svg version="1.1"
         class="loader"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px"
         y="0px"
         viewBox="0 0 600 600">
        <polygon points="108.52,0 108.52,49.04 515.48,49.04 0,564.52 35.48,600 550.96,84.52 550.96,491.48 600,491.48 600,0"/>
      </svg>
  </div>
</template>

<script>
export default {
  name: 'site-loader'
}
</script>
